define('root/notifications/Podio.Transport.Notifications',['require','jquery','root/notifications/Podio.UI.Notifications','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var $ = require('jquery');
  var Notifications = require('root/notifications/Podio.UI.Notifications');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  var state = Notifications.state;

  function getNotifications(requestData, callback) {
    var url = state.list_path;

    var data = $.extend({
      'offset' : state.chunk * state.per_chunk
    }, requestData);

    transport.getJSON(url, {'requestData': data}, callback);
  }

  function markAsViewed(url, callback) {
    return transport.postJSON(url, {}, callback);
  }

  function markSingleAsViewed(id, callback) {
    var url = routes.json_mark_single_as_viewed_path(id);

    return transport.postJSON(url, {}, callback);
  }

  function star(id, callback) {
    var url = routes.star_notification_path(id);
    transport.postJSON(url, {}, callback);
  }

  function unstar(id, callback) {
    var url = routes.star_notification_path(id);
    transport.deleteJSON(url, {}, callback);
  }

  return {
    getNotifications: getNotifications,
    markAsViewed: markAsViewed,
    markSingleAsViewed: markSingleAsViewed,
    star: star,
    unstar: unstar
  };

});

